import { CodedError } from '../CodedError';
import { errorCodes } from '../constants/errorCodes';

export default class ChannelModuleNotFoundError extends CodedError {
  static get errorName() {
    return errorCodes.channelModuleNotFoundError.code;
  }

  constructor(message: string = errorCodes.channelModuleNotFoundError.message) {
    super(message);
    this.code = errorCodes.channelModuleNotFoundError.code;
    this.message = `${message} ${errorCodes.channelModuleNotFoundError.code}`;
    this.name = errorCodes.channelModuleNotFoundError.name;
    this.status = errorCodes.channelModuleNotFoundError.status;
  }
}
